export const GET_PROFITABLE_REPORTS = "GET_PROFITABLE_REPORTS";
export const GET_LIASONPROCESSOWNER = "GET_LIASONPROCESSOWNER";
export const GET_PROJECT_NAMES = "GET_PROJECT_NAMES";
export const GET_TASK_DELAYS = "GET_TASK_DELAYS";
export const GET_PROFITABLE_REPORT_COUNT = "GET_PROFITABLE_REPORT_COUNT";
export const GET_PENDING_TASK = "GET_PENDING_TASK";
export const GET_LIAISON_PROJECT_NAMES = "GET_LIAISON_PROJECT_NAMES";
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
// export const OTP_SENT_SUCCESS = 'OTP_SENT_SUCCESS';
// export const OTP_VALID_SUCCESS = 'OTP_VALID_SUCCESS';
// export const OTP_VALID_FAILS = 'OTP_VALID_FAILS';
export const GET_USER_DASHBOARD_DATA = "GET_USER_DASHBOARD_DATA";
export const GET_USER_DASHBOARD_TASK = "GET_USER_DASHBOARD_TASK";
export const GET_CIVIL_PROCESS_DATA = "GET_CIVIL_PROCESS_DATA";
export const GET_DASHBOARD_AQUIRED_BUT_PLAN_APPROVAL_PENDING_ZONE_DATA =
  "GET_DASHBOARD_AQUIRED_BUT_PLAN_APPROVAL_PENDING_ZONE_DATA";
export const GET_DASHBOARD_AQUIRED_BUT_PLAN_APPROVAL_PENDING_PROJECT_DATA =
  "GET_DASHBOARD_AQUIRED_BUT_PLAN_APPROVAL_PENDING_PROJECT_DATA";
export const GET_DASHBOARD_AQUIRED_BUT_PLAN_APPROVAL_PENDING_FILE_DATA =
  "GET_DASHBOARD_AQUIRED_BUT_PLAN_APPROVAL_PENDING_FILE_DATA";
export const GET_DASHBOARD_PLAN_APPROVAL_APPLIED_ZONE_DATA =
  "GET_DASHBOARD_PLAN_APPROVAL_APPLIED_ZONE_DATA";
export const GET_DASHBOARD_PLAN_APPROVAL_APPLIED_PROJECT_DATA =
  "GET_DASHBOARD_PLAN_APPROVAL_APPLIED_PROJECT_DATA";
export const GET_DASHBOARD_PLAN_APPROVAL_APPLIED_FILE_DATA =
  "GET_DASHBOARD_PLAN_APPROVAL_APPLIED_FILE_DATA";
export const SET_FUNNEL_ITEM_ID = "SET_FUNNEL_ITEM_ID";
export const GET_DASHBOARD_STOCK_ZONE_DATA = "GET_DASHBOARD_STOCK_ZONE_DATA";
export const GET_DASHBOARD_STOCK_PROJECT_DATA =
  "GET_DASHBOARD_STOCK_PROJECT_DATA";
export const GET_DASHBOARD_STOCK_PROJECT_SITE_DATA =
  "GET_DASHBOARD_STOCK_PROJECT_SITE_DATA";
export const GET_DASHBOARD_STOCK_AGING_ZONE_DATA =
  "GET_DASHBOARD_STOCK_AGING_ZONE_DATA";
export const GET_DASHBOARD_STOCK_AGING_PROJECT_DATA =
  "GET_DASHBOARD_STOCK_AGING_PROJECT_DATA";
export const GET_DASHBOARD_STOCK_AGING_FILE_DATA =
  "GET_DASHBOARD_STOCK_AGING_FILE_DATA";
export const GET_DASHBOARD_LAND_AQUIRED_ZONE_DATA =
  "GET_DASHBOARD_LAND_AQUIRED_ZONE_DATA";
export const GET_DASHBOARD_LAND_AQUIRED_PROJECT_DATA =
  "GET_DASHBOARD_LAND_AQUIRED_PROJECT_DATA";
export const GET_DASHBOARD_LAND_AQUIRED_FILE_DATA =
  "GET_DASHBOARD_LAND_AQUIRED_FILE_DATA";
export const GET_DASHBOARD_APPLAN_APPROVAL_ZONE_DATA =
  "GET_DASHBOARD_APPLAN_APPROVAL_ZONE_DATA";
export const GET_DASHBOARD_APPLAN_APPROVAL_PROJECT_DATA =
  "GET_DASHBOARD_APPLAN_APPROVAL_PROJECT_DATA";
export const GET_DASHBOARD_APPLAN_APPROVAL_FILE_DATA =
  "GET_DASHBOARD_APPLAN_APPROVAL_FILE_DATA";
// ________BD chart data seperate___________
export const GET_DASHBOARD_LAND_AQUIRED_FINANCIAL_YEAR_DATA =
  "GET_DASHBOARD_LAND_AQUIRED_FINANCIAL_YEAR_DATA";
export const GET_DASHBOARD_PLAN_APPROVAL_FINANCIAL_YEAR_DATA =
  "GET_DASHBOARD_PLAN_APPROVAL_FINANCIAL_YEAR_DATA";
export const GET_DASHBOARD_PLAN_APPROVED_TARGET_ACTUAL_FINANCIAL_YEAR_DATA =
  "GET_DASHBOARD_PLAN_APPROVED_TARGET_ACTUAL_FINANCIAL_YEAR_DATA";
export const GET_DASHBOARD_DATA_DEPARTMENT = "GET_DASHBOARD_DATA_DEPARTMENT";
export const GET_DASHBOARD_DEPARTMENT = "GET_DASHBOARD_DEPARTMENT";
export const GET_LIAISON_PROCESS_PLAN_REPORT =
  "GET_LIAISON_PROCESS_PLAN_REPORT";
export const GET_LIAISON_PROCESS_PLAN_REPORT_DETAIL =
  "GET_LIAISON_PROCESS_PLAN_REPORT_DETAIL";
export const GET_MY_DASHBOARD_DATA_FILTER_USER =
  "GET_MY_DASHBOARD_DATA_FILTER_USER";
export const GET_DASHBOARD_CRM_PROJECT_OUTSTANDING =
  "GET_DASHBOARD_CRM_PROJECT_OUTSTANDING";
export const GET_DASHBOARD_CRM_PROJECT_OUTSTANDING_EXPORT =
  "GET_DASHBOARD_CRM_PROJECT_OUTSTANDING_EXPORT";
export const GET_DASHBOARD_CRM_SITE_OUTSTANDING =
  "GET_DASHBOARD_CRM_SITE_OUTSTANDING";
export const GET_DASHBOARD_CRM_SITE_OUTSTANDING_EXPORT =
  "GET_DASHBOARD_CRM_SITE_OUTSTANDING_EXPORT";
export const GET_DASHBOARD_CRM_PROJECT_TARGET =
  "GET_DASHBOARD_CRM_PROJECT_TARGET";
export const GET_DASHBOEAR_CRM_SITE_TARGET = "GET_DASHBOEAR_CRM_SITE_TARGET";
export const GET_DASHBOARD_CRM_PROJECT_RECEIVED =
  "GET_DASHBOARD_CRM_PROJECT_RECEIVED";
export const GET_DASHBOARD_CRM_SITE_RECEIVED =
  "GET_DASHBOARD_CRM_SITE_RECEIVED";
export const GET_DASHBOARD_CRM_PROJECT_REALIZED =
  "GET_DASHBOARD_CRM_PROJECT_REALIZED";
export const GET_DAHSBOARD_CRM_SITE_REALIZED =
  "GET_DAHSBOARD_CRM_SITE_REALIZED";
export const GET_DASHBOARD_CRM_PROJECT_NOT_REALIZED =
  "GET_DASHBOARD_CRM_PROJECT_NOT_REALIZED";
export const GET_DAHSBOARD_CRM_SITE_NOT_REALIZED =
  "GET_DAHSBOARD_CRM_SITE_NOT_REALIZED";
export const GET_DASHBOARD_DATA_PRE_SALES = "GET_DASHBOARD_DATA_PRE_SALES";
export const GET_DASHBOARD_DATA_MARKETING_FUNNEL =
  "GET_DASHBOARD_DATA_MARKETING_FUNNEL";
export const GET_GRN_ON_TIME_REPORT = "GET_GRN_ON_TIME_REPORT";
export const GET_GRN_ON_TIME_REPORT_EXPORT = "GET_GRN_ON_TIME_REPORT_EXPORT";
export const GET_VENDOR_LEAD_TIME_REPORT = "GET_VENDOR_LEAD_TIME_REPORT";
export const GET_VENDOR_LEAD_TIME_REPORT_EXPORT =
  "GET_VENDOR_LEAD_TIME_REPORT_EXPORT";
export const GET_STOCK_PROJECT = "GET_STOCK_PROJECT";
export const GET_PURCHASE_INVOICE_ON_TIME_KPI =
  "GET_PURCHASE_INVOICE_ON_TIME_KPI";
export const GET_PURCHASE_INVOICE_ON_TIME_KPI_EXPORT =
  "GET_PURCHASE_INVOICE_ON_TIME_KPI_EXPORT";
export const GET_PURCHASE_INVOICE_ON_TIME_KPI_REPORT =
  "GET_PURCHASE_INVOICE_ON_TIME_KPI_REPORT";
export const GET_PURCHASE_INVOICE_ON_TIME_KPI_REPORT_EXPORT =
  "GET_PURCHASE_INVOICE_ON_TIME_KPI_REPORT_EXPORT";
export const GET_MATERIAL_QUANTITY_REJECTION_KPI =
  "GET_MATERIAL_QUANTITY_REJECTION_KPI";
export const GET_MATERIAL_QUANTITY_REJECTION_KPI_EXPORT =
  "GET_MATERIAL_QUANTITY_REJECTION_KPI_EXPORT";
export const GET_MATERIAL_QUANTITY_REJECTION_KPI_REPORT =
  "GET_MATERIAL_QUANTITY_REJECTION_KPI_REPORT";
export const GET_MATERIAL_QUANTITY_REJECTION_KPI_REPORT_EXPORT =
  "GET_MATERIAL_QUANTITY_REJECTION_KPI_REPORT_EXPORT";
export const GET_INDENT_PURCHASE_ORDER_KPI_REPORT =
  "GET_INDENT_PURCHASE_ORDER_KPI_REPORT";
export const GET_INDENT_PURCHASE_ORDER_KPI_REPORT_EXPORT =
  "GET_INDENT_PURCHASE_ORDER_KPI_REPORT_EXPORT";
export const GET_DASHBOARD_DATA_REGISTRATION_TURN_AROUND_TIME =
  "GET_DASHBOARD_DATA_REGISTRATION_TURN_AROUND_TIME";
export const GET_REGISTRATION_TURNAROUND_TIME_REPORT =
  "GET_REGISTRATION_TURNAROUND_TIME_REPORT";
export const GET_REGISTRATION_TURNAROUND_TIME_REPORT_FILTER_PROJECT =
  "GET_REGISTRATION_TURNAROUND_TIME_REPORT_FILTER_PROJECT";
export const GET_REGISTRATION_TURNAROUND_TIME_REPORT_FILTER_USER =
  "GET_REGISTRATION_TURNAROUND_TIME_REPORT_FILTER_USER";
export const GET_CIVIL_RESOURCE_REPORT = "GET_CIVIL_RESOURCE_REPORT";
export const GET_CIVIL_RESOURCE_REPORT_NON_MATERIAL =
  "GET_CIVIL_RESOURCE_REPORT_NON_MATERIAL";
export const GET_ON_TIME_DELIVERY_KPI = "GET_ON_TIME_DELIVERY_KPI";
export const GET_ON_TIME_DELIVERY_KPI_EXPORT =
  "GET_ON_TIME_DELIVERY_KPI_EXPORT";
export const GET_ON_TIME_DELIVERY_KPI_REPORT =
  "GET_ON_TIME_DELIVERY_KPI_REPORT";
export const GET_ON_TIME_DELIVERY_KPI_REPORT_EXPORT =
  "GET_ON_TIME_DELIVERY_KPI_REPORT_EXPORT";
export const GET_PROCUREMENT_KPI_REPORT = "GET_PROCUREMENT_KPI_REPORT";
export const GET_SALES_CRM_REPORT = "GET_SALES_CRM_REPORT";
export const GET_SALES_CRM_REPORT_EXPORT = "GET_SALES_CRM_REPORT_EXPORT";
export const GET_CRM_PROJECTS = "GET_CRM_PROJECTS";
export const GET_SCALE_TYPE = "GET_SCALE_TYPE";
export const GET_CRM_SITE = "GET_CRM_SITE";
export const GET_CRM_SITE_DIMENSION = "GET_CRM_SITE_DIMENSION";
export const GET_KPI_SALES_REPORT = "GET_KPI_SALES_REPORT";
export const GET_KPI_SALES_REPORT_EXPORT = "GET_KPI_SALES_REPORT_EXPORT";
export const GET_KPI_SALES_REPORT_EXECUTIVE_FILTER =
  "GET_KPI_SALES_REPORT_EXECUTIVE_FILTER";
export const GET_KPI_SALES_REPORT_DETAILS = "GET_KPI_SALES_REPORT_DETAILS";
export const GET_KPI_SALES_REPORT_DETAILS_PROJECT_FILTER =
  "GET_KPI_SALES_REPORT_DETAILS_PROJECT_FILTER";
export const GET_KPI_SALES_REPORT_DETAILS_EXPORT =
  "GET_KPI_SALES_REPORT_DETAILS_EXPORT";
export const GET_KPI_PRE_SALES_REPORT = "GET_KPI_PRE_SALES_REPORT";
export const GET_KPI_PRE_SALES_REPORT_EXPORT =
  "GET_KPI_PRE_SALES_REPORT_EXPORT";
export const GET_KPI_PRE_SALES_REPORT_EXECUTIVE_FILTER =
  "GET_KPI_PRE_SALES_REPORT_EXECUTIVE_FILTER";
export const GET_KPI_SALES_PRE_REPORT_DETAILS =
  "GET_KPI_SALES_PRE_REPORT_DETAILS";
export const GET_KPI_PRE_SALES_REPORT_DETAILS_PROJECT_FILTER =
  "GET_KPI_PRE_SALES_REPORT_DETAILS_PROJECT_FILTER";
export const GET_KPI_SALES_PRE_REPORT_DETAILS_EXPORT =
  "GET_KPI_SALES_PRE_REPORT_DETAILS_EXPORT";
export const GET_KPI_SALES_CRM_REPORT = "GET_KPI_SALES_CRM_REPORT";
export const GET_KPI_SALES_CRM_REPORT_EXPORT =
  "GET_KPI_SALES_CRM_REPORT_EXPORT";
export const GET_KPI_SALES_CRM_REPORT_PROJECT_FILTER =
  "GET_KPI_SALES_CRM_REPORT_PROJECT_FILTER";
export const GET_KPI_SALES_CRM_REPORT_SOURCE_FILTER =
  "GET_KPI_SALES_CRM_REPORT_SOURCE_FILTER";
export const GET_KPI_SALES_CRM_REPORT_SALES_EXECUTIVE_FILTER =
  "GET_KPI_SALES_CRM_REPORT_SALES_EXECUTIVE_FILTER";
export const GET_KPI_SALES_REPORT2 = "GET_KPI_SALES_REPORT2";
export const GET_KPI_SALES_REPORT2_EXPORT = "GET_KPI_SALES_REPORT2_EXPORT";
export const GET_KPI_SALES_SUMMARY_REPORT = "GET_KPI_SALES_SUMMARY_REPORT";
export const GET_KPI_SALES_SUMMARY_REPORT_EXPORT =
  "GET_KPI_SALES_SUMMARY_REPORT_EXPORT";
export const GET_KPI_SALES_SUMMARY_REPORT_DETAILS =
  "GET_KPI_SALES_SUMMARY_REPORT_DETAILS";
export const GET_KPI_SALES_SUMMARY_REPORT_DETAILS_EXPORT =
  "GET_KPI_SALES_SUMMARY_REPORT_DETAILS_EXPORT";
export const GET_KPI_TELECALLING_REPORT = "GET_KPI_TELECALLING_REPORT";
export const GET_KPI_TELECALLING_REPORT_EXPORT =
  "GET_KPI_TELECALLING_REPORT_EXPORT";
export const GET_KPI_SALES_REPORT_LEAD_ASSIGNED_DETAIL =
  "GET_KPI_SALES_REPORT_LEAD_ASSIGNED_DETAIL";
export const GET_KPI_SALES_REPORT_LEAD_ASSIGNED_DETAIL_EXPORT =
  "GET_KPI_SALES_REPORT_LEAD_ASSIGNED_DETAIL_EXPORT";
export const GET_KPI_SALES_REPORT_SITE_VISIT_DETAIL =
  "GET_KPI_SALES_REPORT_SITE_VISIT_DETAIL";
export const GET_KPI_SALES_REPORT_SITE_VISIT_DETAIL_EXPORT =
  "GET_KPI_SALES_REPORT_SITE_VISIT_DETAIL_EXPORT";
export const GET_KPI_SALES_REPORT_CRM_BOOKING_DETAILS =
  "GET_KPI_SALES_REPORT_CRM_BOOKING_DETAILS";
export const GET_KPI_SALES_REPORT_CRM_BOOKING_DETAILS_EXPORT =
  "GET_KPI_SALES_REPORT_CRM_BOOKING_DETAILS_EXPORT";
export const GET_KPI_SALES_REPORT_CRM_CANCELLATION_DETAILS =
  "GET_KPI_SALES_REPORT_CRM_CANCELLATION_DETAILS";
export const GET_CAMPAIGN_REPORT = "GET_CAMPAIGN_REPORT";
export const GET_CAMPAIGN_REPORT_EXPORT = "GET_CAMPAIGN_REPORT_EXPORT";
export const GET_CAMPAIGN_REPORT_FILTER_CAMPAIGN =
  "GET_CAMPAIGN_REPORT_FILTER_CAMPAIGN";
export const GET_KPI_SALES_REPORT_SITE_VISIT_DETAILS_EXPORT =
  "GET_KPI_SALES_REPORT_SITE_VISIT_DETAILS_EXPORT";
export const GET_CAMPAIGN_PROJECT_REPORT = "GET_CAMPAIGN_PROJECT_REPORT";
export const GET_CAMPAIGN_PROJECT_REPORT_EXPORT =
  "GET_CAMPAIGN_PROJECT_REPORT_EXPORT";
export const GET_CAMPAIGN_PROJECT_REPORT_FILTER_PROJECT =
  "GET_CAMPAIGN_PROJECT_REPORT_FILTER_PROJECT";
export const GET_CAMPAIGN_ENQUIRY_REPORT = "GET_CAMPAIGN_ENQUIRY_REPORT";
export const GET_CAMPAIGN_ENQUIRY_REPORT_EXPORT =
  "GET_CAMPAIGN_ENQUIRY_REPORT_EXPORT";
export const GET_CAMPAIGN_BOOKING_REPORT = "GET_CAMPAIGN_BOOKING_REPORT";
export const GET_CAMPAIGN_BOOKING_REPORT_EXPORT =
  "GET_CAMPAIGN_BOOKING_REPORT_EXPORT";
export const GET_CAMPAIGN_BOOKING_CANCELLED_REPORT =
  "GET_CAMPAIGN_BOOKING_CANCELLED_REPORT";
export const GET_CAMPAIGN_BOOKING_CANCELLED_REPORT_EXPORT =
  "GET_CAMPAIGN_BOOKING_CANCELLED_REPORT_EXPORT";
export const GET_CAMPAIGN_SITE_VISIT_REPORT = "GET_CAMPAIGN_SITE_VISIT_REPORT";
export const GET_CAMPAIGN_SITE_VISIT_REPORT_EXPORT =
  "GET_CAMPAIGN_SITE_VISIT_REPORT_EXPORT";
export const GET_FINANCIAL_YEAR = "GET_FINANCIAL_YEAR";
export const GET_FINANCIAL_YEAR_SCALE_TYPE = "GET_FINANCIAL_YEAR_SCALE_TYPE";
export const GET_FINANCIAL_YEAR_SCALE_VALUE = "GET_FINANCIAL_YEAR_SCALE_VALUE";
export const GET_KPI_SALES_REPORT_CRM_CANCELLATION_DETAILS_EXPORT =
  "GET_KPI_SALES_REPORT_CRM_CANCELLATION_DETAILS_EXPORT";
export const GET_PRE_SALES_SITE_VISIT = "GET_PRE_SALES_SITE_VISIT";
export const GET_PRE_SALES_SITE_VISIT_EXPORT =
  "GET_PRE_SALES_SITE_VISIT_EXPORT";
export const GET_KPITELECALLING_FILTER_USER = "GET_KPITELECALLING_FILTER_USER";
export const GET_KPI_SALES_SUMMARY_FILTER_USER =
  "GET_KPI_SALES_SUMMARY_FILTER_USER";
export const GET_SALES_REPORT = "GET_SALES_REPORT";
export const GET_SALES_REPORT_EXPORT = "GET_SALES_REPORT_EXPORT";
export const GET_SALES_REPORT_AGREEMENT = "GET_SALES_REPORT_AGREEMENT";
export const GET_SALES_REPORT_AGREEMENT_EXPORT =
  "GET_SALES_REPORT_AGREEMENT_EXPORT";
export const GET_SALES_REPORT_REGISTRATION = "GET_SALES_REPORT_REGISTRATION";
export const GET_SALES_REPORT_REGISTRATION_EXPORT =
  "GET_SALES_REPORT_REGISTRATION_EXPORT";
export const GET_SALES_REPORT_SITE_VISIT = "GET_SALES_REPORT_SITE_VISIT";
export const GET_SALES_REPORT_SITE_VISIT_FILTER_STM =
  "GET_SALES_REPORT_SITE_VISIT_FILTER_STM";
export const GET_SALES_REPORT_FOLLOW_UP_FILTER_STM =
  "GET_SALES_REPORT_FOLLOW_UP_FILTER_STM";
export const GET_SALES_REPORT_BOOKING_FILTER_STM =
  "GET_SALES_REPORT_BOOKING_FILTER_STM";
export const GET_SALES_REPORT_SITE_VISIT_EXPORT =
  "GET_SALES_REPORT_SITE_VISIT_EXPORT";
export const GET_SALES_REPORT_FOLLOW_UP = "GET_SALES_REPORT_FOLLOW_UP";
export const GET_SALES_REPORT_FOLLOW_UP_EXPORT =
  "GET_SALES_REPORT_FOLLOW_UP_EXPORT";
export const GET_SALES_REPORT_PROSPECTIVE_CLIENT =
  "GET_SALES_REPORT_PROSPECTIVE_CLIENT";
export const GET_SALES_REPORT_PROSPECTIVE_CLIENT_EXPORT =
  "GET_SALES_REPORT_PROSPECTIVE_CLIENT_EXPORT";
export const GET_SALES_REPORT_BOOKING = "GET_SALES_REPORT_BOOKING";
export const GET_SALES_REPORT_BOOKING_EXPORT =
  "GET_SALES_REPORT_BOOKING_EXPORT";
export const GET_SALES_REPORT_CANCELLATION = "GET_SALES_REPORT_CANCELLATION";
export const GET_SALES_REPORT_CANCELLATION_EXPORT =
  "GET_SALES_REPORT_CANCELLATION_EXPORT";
export const GET_SALES_REPORT_HOT_PROSPECTIVE_CLIENT =
  "GET_SALES_REPORT_HOT_PROSPECTIVE_CLIENT";
export const GET_SALES_REPORT_HOT_PROSPECTIVE_CLIENT_EXPORT =
  "GET_SALES_REPORT_HOT_PROSPECTIVE_CLIENT_EXPORT";
export const GET_MONTH_WEEK = "GET_MONTH_WEEK";
export const GET_SALES_REPORT_PLANNED_CP_MEETING =
  "GET_SALES_REPORT_PLANNED_CP_MEETING";
export const GET_SALES_REPORT_PLANNED_CP_MEETING_EXPORT =
  "GET_SALES_REPORT_PLANNED_CP_MEETING_EXPORT";
export const GET_SALES_REPORT_CLIENT_MEETING =
  "GET_SALES_REPORT_CLIENT_MEETING";
export const GET_SALES_REPORT_CLIENT_MEETING_EXPORT =
  "GET_SALES_REPORT_CLIENT_MEETING_EXPORT";
export const GET_SALES_REPORT_TEAM = "GET_SALES_REPORT_TEAM";
export const GET_SALES_REPORT_TEAM_EXPORT = "GET_SALES_REPORT_TEAM_EXPORT";
export const GET_SALES_REPORT_FILTER_TEAM = "GET_SALES_REPORT_FILTER_TEAM";
export const GET_SALES_REPORT_FILTER_USER = "GET_SALES_REPORT_FILTER_USER";
export const GET_SALES_REPORT_PLANNED_FOLLOW_UP =
  "GET_SALES_REPORT_PLANNED_FOLLOW_UP";
export const GET_SALES_REPORT_PLANNED_FOLLOW_UP_EXPORT =
  "GET_SALES_REPORT_PLANNED_FOLLOW_UP_EXPORT";
export const GET_SALES_REPORT_PLANNED_SITE_VISIT =
  "GET_SALES_REPORT_PLANNED_SITE_VISIT";
export const GET_SALES_REPORT_PLANNED_SITE_VISIT_EXPORT =
  "GET_SALES_REPORT_PLANNED_SITE_VISIT_EXPORT";
export const GET_KPI_SALES_REPORT_CRM_BOOKING_DETAIL_FILTER_PROJECT =
  "GET_KPI_SALES_REPORT_CRM_BOOKING_DETAIL_FILTER_PROJECT";
export const GET_KPI_SALES_REPORT_CRM_CANCELLATION_DETAIL_FILTER_PROJECT =
  "GET_KPI_SALES_REPORT_CRM_CANCELLATION_DETAIL_FILTER_PROJECT";
export const GET_KPI_SALES_REPORT_SITE_VISIT_DETAIL_FILTER_PROJECT =
  "GET_KPI_SALES_REPORT_SITE_VISIT_DETAIL_FILTER_PROJECT";
export const GET_SALES_REPORT_COMPLETED_CP_MEETING =
  "GET_SALES_REPORT_COMPLETED_CP_MEETING";
export const GET_SALES_REPORT_COMPLETED_CP_MEETING_EXPORT =
  "GET_SALES_REPORT_COMPLETED_CP_MEETING_EXPORT";
export const GET_SALES_REPORT_PLANNED_CLIENT_MEETING =
  "GET_SALES_REPORT_PLANNED_CLIENT_MEETING";
export const GET_SALES_REPORT_PLANNED_CLIENT_MEETING_EXPORT =
  "GET_SALES_REPORT_PLANNED_CLIENT_MEETING_EXPORT";
export const GET_SALES_REPORT_COMPLETED_CLIENT_MEETING =
  "GET_SALES_REPORT_COMPLETED_CLIENT_MEETING";
export const GET_SALES_REPORT_COMPLETED_CLIENT_MEETING_EXPORT =
  "GET_SALES_REPORT_COMPLETED_CLIENT_MEETING_EXPORT";
export const GET_SALES_REPORT_ENQUIRY_FOLLOW_UP =
  "GET_SALES_REPORT_ENQUIRY_FOLLOW_UP";
export const GET_SALES_REPORT_ENQUIRY_FOLLOW_UP_EXPORT =
  "GET_SALES_REPORT_ENQUIRY_FOLLOW_UP_EXPORT";
//cp sales Report
export const GET_SALES_CHANNEL_PARTNER_REPORT =
  "GET_SALES_CHANNEL_PARTNER_REPORT";
export const GET_SALES_CHANNEL_PARTNER_REPORT_EXPORT =
  "GET_SALES_CHANNEL_PARTNER_REPORT_EXPORT";
export const GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT =
  "GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT";
export const GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT_EXPORT =
  "GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT_EXPORT";
export const GET_SALES_CHANNEL_PARTNER_ENQUIRY_REPORT =
  "GET_SALES_CHANNEL_PARTNER_ENQUIRY_REPORT";
export const GET_SALES_CHANNEL_PARTNER_ENQUIRY_REPORT_EXPORT =
  "GET_SALES_CHANNEL_PARTNER_ENQUIRY_REPORT_EXPORT";
export const GET_SALES_CHANNEL_PARTNER_SITE_VISIT_REPORT =
  "GET_SALES_CHANNEL_PARTNER_SITE_VISIT_REPORT";
export const GET_SALES_CHANNEL_PARTNER_SITE_VISIT_REPORT_EXPORT =
  "GET_SALES_CHANNEL_PARTNER_SITE_VISIT_REPORT_EXPORT";
export const GET_SALES_CHANNEL_PARTNER_BOOKING_REPORT =
  "GET_SALES_CHANNEL_PARTNER_BOOKING_REPORT";
export const GET_SALES_CHANNEL_PARTNER_BOOKING_REPORT_EXPORT =
  "GET_SALES_CHANNEL_PARTNER_BOOKING_REPORT_EXPORT";
export const GET_SALES_CHANNEL_PARTNER_CANCELLATION_REPORT =
  "GET_SALES_CHANNEL_PARTNER_CANCELLATION_REPORT";
export const GET_SALES_CHANNEL_PARTNER_CANCELLATION_REPORT_EXPORT =
  "GET_SALES_CHANNEL_PARTNER_CANCELLATION_REPORT_EXPORT";
export const GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT_FILTER_PROJECT =
  "GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT_FILTER_PROJECT";
export const GET_SALES_CHANNEL_PARTNER_ENQUIRY_REPORT_FILTER_PROJECT =
  "GET_SALES_CHANNEL_PARTNER_ENQUIRY_REPORT_FILTER_PROJECT";
export const GET_SALES_CHANNEL_PARTNER_SITE_VISIT_REPORT_FILTER_PROJECT =
  "GET_SALES_CHANNEL_PARTNER_SITE_VISIT_REPORT_FILTER_PROJECT";
export const GET_SALES_CHANNEL_PARTNER_BOOKING_REPORT_FILTER_PROJECT =
  "GET_SALES_CHANNEL_PARTNER_BOOKING_REPORT_FILTER_PROJECT";
export const GET_SALES_CHANNEL_PARTNER_CANCELLATION_REPORT_FILTER_PROJECT =
  "GET_SALES_CHANNEL_PARTNER_CANCELLATION_REPORT_FILTER_PROJECT";
//source sales Report
export const GET_SALES_SOURCE_REPORT = "GET_SALES_SOURCE_REPORT";
export const GET_SALES_SOURCE_REPORT_EXPORT = "GET_SALES_SOURCE_REPORT_EXPORT";
export const GET_SALES_SOURCE_PROJECT_REPORT =
  "GET_SALES_SOURCE_PROJECT_REPORT";
export const GET_SALES_SOURCE_PROJECT_REPORT_EXPORT =
  "GET_SALES_SOURCE_PROJECT_REPORT_EXPORT";
export const GET_SALES_SOURCE_ENQUIRY_REPORT =
  "GET_SALES_SOURCE_ENQUIRY_REPORT";
export const GET_SALES_SOURCE_ENQUIRY_REPORT_FILTER_SOURCE =
  "GET_SALES_SOURCE_ENQUIRY_REPORT_FILTER_SOURCE";
export const GET_SALES_SOURCE_SITE_VISIT_REPORT_FILTER_SOURCE =
  "GET_SALES_SOURCE_SITE_VISIT_REPORT_FILTER_SOURCE";
export const GET_SALES_SOURCE_BOOKING_REPORT_FILTER_SOURCE =
  "GET_SALES_SOURCE_BOOKING_REPORT_FILTER_SOURCE";
export const GET_SALES_SOURCE_CANCELLATION_REPORT_FILTER_SOURCE =
  "GET_SALES_SOURCE_CANCELLATION_REPORT_FILTER_SOURCE";
export const GET_SALES_SOURCE_ENQUIRY_REPORT_EXPORT =
  "GET_SALES_SOURCE_ENQUIRY_REPORT_EXPORT";
export const GET_SALES_SOURCE_SITE_VISIT_REPORT =
  "GET_SALES_SOURCE_SITE_VISIT_REPORT";
export const GET_SALES_SOURCE_SITE_VISIT_REPORT_EXPORT =
  "GET_SALES_SOURCE_SITE_VISIT_REPORT_EXPORT";
export const GET_SALES_SOURCE_BOOKING_REPORT =
  "GET_SALES_SOURCE_BOOKING_REPORT";
export const GET_SALES_SOURCE_BOOKING_REPORT_EXPORT =
  "GET_SALES_SOURCE_BOOKING_REPORT_EXPORT";
export const GET_SALES_SOURCE_CANCELLATION_REPORT =
  "GET_SALES_SOURCE_CANCELLATION_REPORT";
export const GET_SALES_SOURCE_CANCELLATION_REPORT_EXPORT =
  "GET_SALES_SOURCE_CANCELLATION_REPORT_EXPORT";
export const GET_SALES_SOURCE_PROJECT_REPORT_FILTER_PROJECT =
  "GET_SALES_SOURCE_PROJECT_REPORT_FILTER_PROJECT";
export const GET_SALES_SOURCE_ENQUIRY_REPORT_FILTER_PROJECT =
  "GET_SALES_SOURCE_ENQUIRY_REPORT_FILTER_PROJECT";
export const GET_SALES_SOURCE_SITE_VISIT_REPORT_FILTER_PROJECT =
  "GET_SALES_SOURCE_SITE_VISIT_REPORT_FILTER_PROJECT";
export const GET_SALES_SOURCE_BOOKING_REPORT_FILTER_PROJECT =
  "GET_SALES_SOURCE_BOOKING_REPORT_FILTER_PROJECT";
export const GET_SALES_SOURCE_CANCELLATION_REPORT_FILTER_PROJECT =
  "GET_SALES_SOURCE_CANCELLATION_REPORT_FILTER_PROJECT";
export const GET_ENQUIRY_SOURCE_CATEGORY = "GET_ENQUIRY_SOURCE_CATEGORY";
export const GET_ENQUIRY_SOURCE_FILTER = "GET_ENQUIRY_SOURCE_FILTER";
export const GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT_FILTER_CHANNEL_PARTNER =
  "GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT_FILTER_CHANNEL_PARTNER";
export const GET_SALES_CHANNEL_PARTNER_ON_BOARD_REPORT =
  "GET_SALES_CHANNEL_PARTNER_ON_BOARD_REPORT";
export const GET_SALES_CHANNEL_PARTNER_ON_BOARD_REPORT_EXPORT =
  "GET_SALES_CHANNEL_PARTNER_ON_BOARD_REPORT_EXPORT";
export const GET_SALES_CHANNEL_PARTNER_REPORT_FILTER_SALES_EXECUTIVE =
  "GET_SALES_CHANNEL_PARTNER_REPORT_FILTER_SALES_EXECUTIVE";
export const GET_PRE_SALES_REPORT = "GET_PRE_SALES_REPORT";
export const GET_PRE_SALES_REPORT_FILTER_EXECUTIVE =
  "GET_PRE_SALES_REPORT_FILTER_EXECUTIVE";
export const GET_PRE_SALES_REPORT_FILTER_SOURCE_CATEGORY =
  "GET_PRE_SALES_REPORT_FILTER_SOURCE_CATEGORY";
export const GET_PRE_SALES_REPORT_FILTER_SOURCE =
  "GET_PRE_SALES_REPORT_FILTER_SOURCE";
export const GET_PRE_SALES_REPORT_FILTER_PROJECT =
  "GET_PRE_SALES_REPORT_FILTER_PROJECT";
export const GET_PRE_SALES_REPORT_EXPORT = "GET_PRE_SALES_REPORT_EXPORT";
export const GET_PRE_SALES_ENQUIRY_REPORT = "GET_PRE_SALES_ENQUIRY_REPORT";
export const GET_PRE_SALES_PROJECT_REPORT = "GET_PRE_SALES_PROJECT_REPORT";
export const GET_PRE_SALES_PROJECT_REPORT_EXPORT =
  "GET_PRE_SALES_PROJECT_REPORT_EXPORT";
export const GET_PRE_SALES_ENQUIRY_REPORT_EXPORT =
  "GET_PRE_SALES_ENQUIRY_REPORT_EXPORT";
export const GET_PRE_SALES_ENQUIRY_OVER_DUE_REPORT =
  "GET_PRE_SALES_ENQUIRY_OVER_DUE_REPORT";
export const GET_PRE_SALES_ENQUIRY_OVER_DUE_REPORT_EXPORT =
  "GET_PRE_SALES_ENQUIRY_OVER_DUE_REPORT_EXPORT";
export const GET_SALES_REPORT_CANCELLATION_PREVIOUS =
  "GET_SALES_REPORT_CANCELLATION_PREVIOUS";
export const GET_SALES_REPORT_CANCELLATION_PREVIOUS_EXPORT =
  "GET_SALES_REPORT_CANCELLATION_PREVIOUS_EXPORT";
export const GET_SALES_REPORT_BOOKING_GROSS = "GET_SALES_REPORT_BOOKING_GROSS";
export const GET_SALES_REPORT_BOOKING_GROSS_EXPORT =
  "GET_SALES_REPORT_BOOKING_GROSS_EXPORT";

//My Dashboard
export const GET_PENDING_DASHBOARD_DATA = "GET_PENDING_DASHBOARD_DATA";
export const GET_PENDING_ACCOUNTABLE_DASHBOARD_DATA =
  "GET_PENDING_ACCOUNTABLE_DASHBOARD_DATA";
export const GET_DASHBOARD_DEPARTMENT_DATA = "GET_DASHBOARD_DEPARTMENT_DATA";
export const GET_PENDING_RESPONSIBLE_DASHBOARD_DATA =
  "GET_PENDING_RESPONSIBLE_DASHBOARD_DATA";

//Liaison Process
export const GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN =
  "GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN";
export const GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_EXPORT =
  "GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_EXPORT";
export const GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_PROJECT =
  "GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_PROJECT";
export const GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_PROCESS =
  "GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_PROCESS";
export const GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_ACCOUNTABLE =
  "GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_ACCOUNTABLE";
export const GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_RESPONSIBLE =
  "GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_RESPONSIBLE";

//Liaison Documenetation
export const GET_DASHBOARD_DATA_DOCUMENTATION_PLAN =
  "GET_DASHBOARD_DATA_DOCUMENTATION_PLAN";
export const GET_DASHBOARD_DATA_DOCUMENTATION_PLAN_EXPORT =
  "GET_DASHBOARD_DATA_DOCUMENTATION_PLAN_EXPORT";
export const GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_PROJECT =
  "GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_PROJECT";
export const GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_CATEGORY =
  "GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_CATEGORY";
export const GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_ACCOUNTABLE =
  "GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_ACCOUNTABLE";
export const GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_RESPONSIBLE =
  "GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_RESPONSIBLE";

//APF Query
export const GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY =
  "GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY";
export const GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_EXPORT =
  "GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_EXPORT";
export const GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_FILTER_PROJECT =
  "GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_FILTER_PROJECT";
export const GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_FILTER_ACCOUNTABLE =
  "GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_FILTER_ACCOUNTABLE";
export const GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_FILTER_RESPONSIBLE =
  "GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_FILTER_RESPONSIBLE";

//Loan Query
export const GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY =
  "GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY";
export const GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_EXPORT =
  "GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_EXPORT";
export const GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_PROJECT =
  "GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_PROJECT";
export const GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_PROCESS =
  "GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_PROCESS";
export const GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_ACCOUNTABLE =
  "GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_ACCOUNTABLE";
export const GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_RESPONSIBLE =
  "GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_RESPONSIBLE";

//Legal Task
export const GET_DASHBOARD_DATA_BD_LEGAL_TASK =
  "GET_DASHBOARD_DATA_BD_LEGAL_TASK";
export const GET_DASHBOARD_DATA_BD_LEGAL_TASK_EXPORT =
  "GET_DASHBOARD_DATA_BD_LEGAL_TASK_EXPORT";
export const GET_DASHBOARD_DATA_BD_LEGAL_TASK_FILTER_PROJECT =
  "GET_DASHBOARD_DATA_BD_LEGAL_TASK_FILTER_PROJECT";
export const GET_DASHBOARD_DATA_BD_LEGAL_TASK_FILTER_ACCOUNTABLE =
  "GET_DASHBOARD_DATA_BD_LEGAL_TASK_FILTER_ACCOUNTABLE";
export const GET_DASHBOARD_DATA_BD_LEGAL_TASK_FILTER_RESPONSIBLE =
  "GET_DASHBOARD_DATA_BD_LEGAL_TASK_FILTER_RESPONSIBLE";

//Boundary Dispute
export const GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE =
  "GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE";
export const GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_EXPORT =
  "GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_EXPORT";
export const GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_FILTER_PROJECT =
  "GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_FILTER_PROJECT";
export const GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_FILTER_ACCOUNTABLE =
  "GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_FILTER_ACCOUNTABLE";
export const GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_FILTER_RESPONSIBLE =
  "GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_FILTER_RESPONSIBLE";

//To Be Acquired
export const GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING =
  "GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING";
export const GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_EXPORT =
  "GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_EXPORT";
export const GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_FILTER_PROJECT =
  "GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_FILTER_PROJECT";
export const GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_FILTER_ACCOUNTABLE =
  "GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_FILTER_ACCOUNTABLE";
export const GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_FILTER_RESPONSIBLE =
  "GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_FILTER_RESPONSIBLE";

//Court Case
export const GET_DASHBOARD_DATA_COURT_CASE = "GET_DASHBOARD_DATA_COURT_CASE";
export const GET_DASHBOARD_DATA_COURT_CASE_EXPORT =
  "GET_DASHBOARD_DATA_COURT_CASE_EXPORT";
export const GET_DASHBOARD_DATA_COURT_CASE_FILTER_PROJECT =
  "GET_DASHBOARD_DATA_COURT_CASE_FILTER_PROJECT";
export const GET_DASHBOARD_DATA_COURT_CASE_FILTER_ACCOUNTABLE =
  "GET_DASHBOARD_DATA_COURT_CASE_FILTER_ACCOUNTABLE";
export const GET_DASHBOARD_DATA_COURT_CASE_FILTER_RESPONSIBLE =
  "GET_DASHBOARD_DATA_COURT_CASE_FILTER_RESPONSIBLE";

//Project Task
export const GET_DASHBOARD_DATA_PROJECT_TASK_PLAN =
  "GET_DASHBOARD_DATA_PROJECT_TASK_PLAN";
export const GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_EXPORT =
  "GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_EXPORT";
export const GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_PROJECT =
  "GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_PROJECT";
export const GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_CATEGORY =
  "GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_CATEGORY";
export const GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_TASK =
  "GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_TASK";
export const GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_ACCOUNTABLE =
  "GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_ACCOUNTABLE";
export const GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_RESPONSIBLE =
  "GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_RESPONSIBLE";

//To do
export const GET_DASHBOARD_DATA_TODO = "GET_DASHBOARD_DATA_TODO";
export const GET_DASHBOARD_DATA_TODO_EXPORT = "GET_DASHBOARD_DATA_TODO_EXPORT";
export const GET_DASHBOARD_DATA_TODO_FILTER_PROJECT =
  "GET_DASHBOARD_DATA_TODO_FILTER_PROJECT";
export const GET_DASHBOARD_DATA_TODO_FILTER_ACCOUNTABLE =
  "GET_DASHBOARD_DATA_TODO_FILTER_ACCOUNTABLE";
export const GET_DASHBOARD_DATA_TODO_FILTER_RESPONSIBLE =
  "GET_DASHBOARD_DATA_TODO_FILTER_RESPONSIBLE";

//Survey
export const GET_DASHBOARD_DATA_PROJECT_SURVEY =
  "GET_DASHBOARD_DATA_PROJECT_SURVEY";
export const GET_DASHBOARD_DATA_PROJECT_SURVEY_EXPORT =
  "GET_DASHBOARD_DATA_PROJECT_SURVEY_EXPORT";
export const GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_PROJECT =
  "GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_PROJECT";
export const GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_TASK =
  "GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_TASK";
export const GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_ACCOUNTABLE =
  "GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_ACCOUNTABLE";
export const GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_RESPONSIBLE =
  "GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_RESPONSIBLE";

//Project Legal
export const GET_DASHBOARD_DATA_PROJECT_LEGAL =
  "GET_DASHBOARD_DATA_PROJECT_LEGAL";
export const GET_DASHBOARD_DATA_PROJECT_LEGAL_EXPORT =
  "GET_DASHBOARD_DATA_PROJECT_LEGAL_EXPORT";
export const GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_PROJECT =
  "GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_PROJECT";
export const GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_TASK =
  "GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_TASK";
export const GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_ACCOUNTABLE =
  "GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_ACCOUNTABLE";
export const GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_RESPONSIBLE =
  "GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_RESPONSIBLE";

//Marketing
//Enquiry Generated
export const GET_DASHBOARD_DATA_ENQUIRY = "GET_DASHBOARD_DATA_ENQUIRY";
export const GET_DASHBOARD_DATA_ENQUIRY_EXPORT =
  "GET_DASHBOARD_DATA_ENQUIRY_EXPORT";
export const GET_DASHBOARD_DATA_ENQUIRY_PROJECT =
  "GET_DASHBOARD_DATA_ENQUIRY_PROJECT";
export const GET_DASHBOARD_DATA_ENQUIRY_SOURCE =
  "GET_DASHBOARD_DATA_ENQUIRY_SOURCE";

//Enquiry Qualificated
export const GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED =
  "GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED";
export const GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_EXPORT =
  "GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_EXPORT";
export const GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_PROJECT =
  "GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_PROJECT";
export const GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_SOURCE =
  "GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_SOURCE";
export const GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_PRE_SALES =
  "GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_PRE_SALES";

//Pre-Sales
//Site Visit
export const GET_DASHBOARD_DATA_SITE_VISIT = "GET_DASHBOARD_DATA_SITE_VISIT";
export const GET_DASHBOARD_DATA_SITE_VISIT_EXPORT =
  "GET_DASHBOARD_DATA_SITE_VISIT_EXPORT";
export const GET_DASHBOARD_DATA_SITE_VISIT_PROJECT =
  "GET_DASHBOARD_DATA_SITE_VISIT_PROJECT";
export const GET_DASHBOARD_DATA_SITE_VISIT_SOURCE =
  "GET_DASHBOARD_DATA_SITE_VISIT_SOURCE";
export const GET_DASHBOARD_DATA_SITE_VISIT_STM =
  "GET_DASHBOARD_DATA_SITE_VISIT_STM";
export const GET_DASHBOARD_DATA_SITE_VISIT_PRE_SALES =
  "GET_DASHBOARD_DATA_SITE_VISIT_PRE_SALES";

//Sales
//Sales
export const GET_DASHBOARD_DATA_SALES_BOOKING =
  "GET_DASHBOARD_DATA_SALES_BOOKING";
export const GET_DASHBOARD_DATA_SALES_BOOKING_EXPORT =
  "GET_DASHBOARD_DATA_SALES_BOOKING_EXPORT";
export const GET_DASHBOARD_DATA_SALES_BOOKIG_FILTER_PROJECT =
  "GET_DASHBOARD_DATA_SALES_BOOKIG_FILTER_PROJECT";
export const GET_DASHBOARD_DATA_SALES_SOURCE =
  "GET_DASHBOARD_DATA_SALES_SOURCE";
export const GET_DASHBOARD_DATA_SALES_BOOKIG_FILTER_BOOKEDBY =
  "GET_DASHBOARD_DATA_SALES_BOOKIG_FILTER_BOOKEDBY";

//Cancellation
export const GET_DASHBOARD_DATA_CANCELLATION =
  "GET_DASHBOARD_DATA_CANCELLATION";
export const GET_DASHBOARD_DATA_CANCELLATION_EXPORT =
  "GET_DASHBOARD_DATA_CANCELLATION_EXPORT";
export const GET_DASHBOARD_DATA_CANCELLATION_PROJECT =
  "GET_DASHBOARD_DATA_CANCELLATION_PROJECT";
export const GET_DASHBOARD_DATA_CANCELLATION_SOURCE =
  "GET_DASHBOARD_DATA_CANCELLATION_SOURCE";
export const GET_DASHBOARD_DATA_CANCELLATION_STM =
  "GET_DASHBOARD_DATA_CANCELLATION_STM";

//CRM
//Collection
export const GET_DASHBOARD_DATA_COLLECTION = "GET_DASHBOARD_DATA_COLLECTION";
export const GET_DASHBOARD_DATA_COLLECTION_EXPORT =
  "GET_DASHBOARD_DATA_COLLECTION_EXPORT";
export const GET_DASHBOARD_DATA_COLLECTION_PROJECT =
  "GET_DASHBOARD_DATA_COLLECTION_PROJECT";
export const GET_DASHBOARD_DATA_COLLECTION_USER =
  "GET_DASHBOARD_DATA_COLLECTION_USER";

//Agreement
export const GET_DASHBOARD_DATA_AGREEMENT = "GET_DASHBOARD_DATA_AGREEMENT";
export const GET_DASHBOARD_DATA_AGREEMENT_EXPORT =
  "GET_DASHBOARD_DATA_AGREEMENT_EXPORT";
export const GET_DASHBOARD_DATA_AGREEMENT_PROJECT =
  "GET_DASHBOARD_DATA_AGREEMENT_PROJECT";
export const GET_DASHBOARD_DATA_AGREEMENT_USER =
  "GET_DASHBOARD_DATA_AGREEMENT_USER";

//Registration
export const GET_DASHBOARD_DATA_REGISTRATION =
  "GET_DASHBOARD_DATA_REGISTRATION";
export const GET_DASHBOARD_DATA_REGISTRATION_EXPORT =
  "GET_DASHBOARD_DATA_REGISTRATION_EXPORT";
export const GET_DASHBOARD_DATA_REGISTRATION_PROJECT =
  "GET_DASHBOARD_DATA_REGISTRATION_PROJECT";
export const GET_DASHBOARD_DATA_REGISTRATION_USER =
  "GET_DASHBOARD_DATA_REGISTRATION_USER";

//mar 6 presales

export const GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP =
  "GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP";
export const GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_EXPORT =
  "GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_EXPORT";
export const GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_FILTER_PROJECT =
  "GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_FILTER_PROJECT";
export const GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_FILTER_SOURCE =
  "GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_FILTER_SOURCE";
export const GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_FILTER_SOURCE_CATEGORY =
  "GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_FILTER_SOURCE_CATEGORY";
export const GET_PRE_SALES_REPORT_FOLLOW_UP = "GET_PRE_SALES_REPORT_FOLLOW_UP";
export const GET_PRE_SALES_REPORT_FOLLOW_UP_FILTER_PROJECT =
  "GET_PRE_SALES_REPORT_FOLLOW_UP_FILTER_PROJECT";
export const GET_PRE_SALES_REPORT_FOLLOW_UP_FILTER_SOURCE =
  "GET_PRE_SALES_REPORT_FOLLOW_UP_FILTER_SOURCE";
export const GET_PRE_SALES_REPORT_FOLLOW_UP_FILTER_SOURCE_CATEGORY =
  "GET_PRE_SALES_REPORT_FOLLOW_UP_FILTER_SOURCE_CATEGORY";
export const GET_PRE_SALES_REPORT_FOLLOW_UP_EXPORT =
  "GET_PRE_SALES_REPORT_FOLLOW_UP_EXPORT";
export const GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT =
  "GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT";
export const GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_FILTER_PROJECT =
  "GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_FILTER_PROJECT";
export const GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_FILTER_SOURCE =
  "GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_FILTER_SOURCE";
export const GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_FILTER_SOURCE_CATEGORY =
  "GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_FILTER_SOURCE_CATEGORY";
export const GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_EXPORT =
  "GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_EXPORT";
export const GET_PRE_SALES_REPORT_ACTUAL_SALES =
  "GET_PRE_SALES_REPORT_ACTUAL_SALES";
export const GET_PRE_SALES_REPORT_ACTUAL_SALES_EXPORT =
  "GET_PRE_SALES_REPORT_ACTUAL_SALES_EXPORT";

export const GET_PRE_SALES_REPORT_ACTUAL_SALES_FILTER_PROJECT =
  "GET_PRE_SALES_REPORT_ACTUAL_SALES_FILTER_PROJECT";
export const GET_PRE_SALES_REPORT_ACTUAL_SALES_FILTER_SOURCE =
  "GET_PRE_SALES_REPORT_ACTUAL_SALES_FILTER_SOURCE";
export const GET_PRE_SALES_REPORT_ACTUAL_SALES_FILTER_SOURCE_CATEGORY =
  "GET_PRE_SALES_REPORT_ACTUAL_SALES_FILTER_SOURCE_CATEGORY";

export const GET_PRE_SALES_REPORT_CANCELLATION =
  "GET_PRE_SALES_REPORT_CANCELLATION";

export const GET_PRE_SALES_REPORT_CANCELLATION_EXPORT =
  "GET_PRE_SALES_REPORT_CANCELLATION_EXPORT";
export const GET_PRE_SALES_REPORT_CANCELLATION_FILTER_PROJECT =
  "GET_PRE_SALES_REPORT_CANCELLATION_FILTER_PROJECT";
export const GET_PRE_SALES_REPORT_CANCELLATION_FILTER_SOURCE =
  "GET_PRE_SALES_REPORT_CANCELLATION_FILTER_SOURCE";
export const GET_PRE_SALES_REPORT_CANCELLATION_FILTER_SOURCE_CATEGORY =
  "GET_PRE_SALES_REPORT_CANCELLATION_FILTER_SOURCE_CATEGORY";
export const GET_PRE_SALES_REPORT_SITE_VISIT_PREVIOUS_ENQUIRY =
  "GET_PRE_SALES_REPORT_SITE_VISIT_PREVIOUS_ENQUIRY";

export const GET_PRE_SALES_REPORT_SITE_VISIT_PREVIOUS_ENQUIRY_EXPORT =
  "GET_PRE_SALES_REPORT_SITE_VISIT_PREVIOUS_ENQUIRY_EXPORT";
export const GET_PRE_SALES_REPORT_SITE_VISIT_ENQUIRY_PROJECT =
  "GET_PRE_SALES_REPORT_SITE_VISIT_ENQUIRY_PROJECT";
export const GET_PRE_SALES_REPORT_SITE_VISIT_FILTER_ENQUIRY_SOURCE =
  "GET_PRE_SALES_REPORT_SITE_VISIT_FILTER_ENQUIRY_SOURCE";
export const GET_PRE_SALES_REPORT_SITE_VISIT_ENQUIRY_FILTER_SOURCE_CATEGORY =
  "GET_PRE_SALES_REPORT_SITE_VISIT_ENQUIRY_FILTER_SOURCE_CATEGORY";
export const GET_PRE_SALES_REPORT_FILTER_DEPARTMENT =
  "GET_PRE_SALES_REPORT_FILTER_DEPARTMENT";

//LEAD REPORT
export const GET_LEAD_SALES_REPORT = "GET_LEAD_SALES_REPORT";
export const GET_LEAD_SALES_REPORT_EXPORT = "GET_LEAD_SALES_REPORT_EXPORT";
export const GET_LEAD_SALES_REPORT_FILTER_CATEGORY =
  "GET_LEAD_SALES_REPORT_FILTER_CATEGORY";
export const GET_LEAD_SALES_REPORT_FILTER_SOURCE =
  "GET_LEAD_SALES_REPORT_FILTER_SOURCE";
export const GET_LEAD_SALES_REPORT_FILTER_SUB_SOURCE =
  "GET_LEAD_SALES_REPORT_FILTER_SUB_SOURCE";
export const GET_LEAD_SALES_ENQUIRY_REPORT = "GET_LEAD_SALES_ENQUIRY_REPORT";
export const GET_LEAD_SALES_ENQUIRY_REPORT_EXPORT =
  "GET_LEAD_SALES_ENQUIRY_REPORT_EXPORT";
export const GET_SOURCE_SUMMARY_REPORT_ACTUAL_SITE_VISIT =
  "GET_SOURCE_SUMMARY_REPORT_ACTUAL_SITE_VISIT";
export const GET_SOURCE_SUMMARY_REPORT_ACTUAL_SALES =
  "GET_SOURCE_SUMMARY_REPORT_ACTUAL_SALES";
export const GET_SOURCE_SUMMARY_REPORT_CANCELLATION =
  "GET_SOURCE_SUMMARY_REPORT_CANCELLATION";
export const GET_SOURCE_SUMMARY_ENQUIRY_REPORT_FILTER_PROJECT =
  "GET_SOURCE_SUMMARY_ENQUIRY_REPORT_FILTER_PROJECT";
export const GET_SOURCE_SUMMARY_REPORT_ACTUAL_SITE_VISIT_FILTER_PROJECT =
  "GET_SOURCE_SUMMARY_REPORT_ACTUAL_SITE_VISIT_FILTER_PROJECT";
export const GET_SOURCE_SUMMARY_REPORT_ACTUAL_SALES_FILTER_PROJECT =
  "GET_SOURCE_SUMMARY_REPORT_ACTUAL_SALES_FILTER_PROJECT";
export const GET_SOURCE_SUMMARY_REPORT_CANCELLATION_FILTER_PROJECT =
  "GET_SOURCE_SUMMARY_REPORT_CANCELLATION_FILTER_PROJECT";
export const GET_SOURCE_SUMMARY_REPORT_ACTUAL_SITE_VISIT_EXPORT =
  "GET_SOURCE_SUMMARY_REPORT_ACTUAL_SITE_VISIT_EXPORT";
export const GET_SOURCE_SUMMARY_REPORT_ACTUAL_SALES_EXPORT =
  "GET_SOURCE_SUMMARY_REPORT_ACTUAL_SALES_EXPORT";
export const GET_SOURCE_SUMMARY_REPORT_CANCELLATION_EXPORT =
  "GET_SOURCE_SUMMARY_REPORT_CANCELLATION_EXPORT";
export const GET_LEAD_SALES_REPORT_FILTER_PROJECT =
  "GET_LEAD_SALES_REPORT_FILTER_PROJECT";

//FILTER PROJECT

export const GET_SALES_REPORT_PLANNED_FOLLOWUP_FILTER_PROJECT =
  "GET_SALES_REPORT_PLANNED_FOLLOWUP_FILTER_PROJECT";
export const GET_SALES_REPORT_FOLLOW_UP_FILTER_PROJECT =
  "GET_SALES_REPORT_FOLLOW_UP_FILTER_PROJECT";
export const GET_SALES_REPORT_PLANNED_SITE_VISIT_FILTER_PROJECT =
  "GET_SALES_REPORT_PLANNED_SITE_VISIT_FILTER_PROJECT";
export const GET_SALES_REPORT_SITE_VISIT_FILTER_PROJECT =
  "GET_SALES_REPORT_SITE_VISIT_FILTER_PROJECT";
export const GET_SALES_REPORT_BOOKING_FILTER_PROJECT =
  "GET_SALES_REPORT_BOOKING_FILTER_PROJECT";
export const GET_SALES_REPORT_CANCELLATION_FILTER_PROJECT =
  "GET_SALES_REPORT_CANCELLATION_FILTER_PROJECT";
export const GET_SALES_REPORT_AGREEMENT_FILTER_PROJECT =
  "GET_SALES_REPORT_AGREEMENT_FILTER_PROJECT";
export const GET_SALES_REPORT_REGISTRATION_FILTER_PROJECT =
  "GET_SALES_REPORT_REGISTRATION_FILTER_PROJECT";
export const GET_SALES_REPORT_BOOKING_GROSS_FILTER_PROJECT =
  "GET_SALES_REPORT_BOOKING_GROSS_FILTER_PROJECT";
export const GET_SALES_REPORT_CANCELLATION_PREVIOUS_FILTER_REPORT =
  "GET_SALES_REPORT_CANCELLATION_PREVIOUS_FILTER_REPORT";
export const GET_SALES_REPORT_PLANNED_CP_MEETING_FILTER_PROJECT =
  "GET_SALES_REPORT_PLANNED_CP_MEETING_FILTER_PROJECT";
export const GET_SALES_REPORT_PLANNED_COMPLETED_CP_MEETING_FILTER_PROJECT =
  "GET_SALES_REPORT_PLANNED_COMPLETED_CP_MEETING_FILTER_PROJECT";
export const GET_SALES_REPORT_PLANNED_CLIENT_MEETING_FILTER_PROJECT =
  "GET_SALES_REPORT_PLANNED_CLIENT_MEETING_FILTER_PROJECT";
export const GET_SALES_REPORT_COMPLETED_CLIENT_MEETING_FILTER_PROJECT =
  "GET_SALES_REPORT_COMPLETED_CLIENT_MEETING_FILTER_PROJECT";
// ------------callReport-pk--------------
export const GET_CALL_SUMMARY_REPORT = "GET_CALL_SUMMARY_REPORT";
export const GET_CALL_SUMMARY_REPORT_EXPORT = "GET_CALL_SUMMARY_REPORT_EXPORT";

export const GET_CALL_SUMMARY_FILTER_EXECUTIVE =
  "GET_CALL_SUMMARY_FILTER_EXECUTIVE";

export const GET_CALL_SUMMARY_TOTAL_CALL_REPORT =
  "GET_CALL_SUMMARY_TOTAL_CALL_REPORT";
export const GET_CALL_SUMMARY_TOTAL_CALL_REPORT_EXPORT =
  "GET_CALL_SUMMARY_TOTAL_CALL_REPORT_EXPORT";
export const GET_CALL_SUMMARY_REPEAT_CALL_REPORT =
  "GET_CALL_SUMMARY_REPEAT_CALL_REPORT";
export const GET_CALL_SUMMARY_REPEAT_CALL_REPORT_EXPORT =
  "GET_CALL_SUMMARY_REPEAT_CALL_REPORT_EXPORT";
export const GET_CALL_SUMMARY_FRESH_CALL_REPORT =
  "GET_CALL_SUMMARY_FRESH_CALL_REPORT";
export const GET_CALL_SUMMARY_FRESH_CALL_REPORT_EXPORT =
  "GET_CALL_SUMMARY_FRESH_CALL_REPORT_EXPORT";

export const GET_PROCUMENT_REPORT = "GET_PROCUMENT_REPORT";
export const GET_PROCUMENT_REPORT_DETAIL = "GET_PROCUMENT_REPORT_DETAIL";

export const GET_PROCUMENT_REPORT_EXPORT = "GET_PROCUMENT_REPORT_EXPORT";
export const GET_PROCUMENT_REPORT_FILTER_PROJECT =
  "GET_PROCUMENT_REPORT_FILTER_PROJECT";
export const GET_PROCUMENT_REPORT_FILTER_VENDOR =
  "GET_PROCUMENT_REPORT_FILTER_VENDOR";
export const GET_PROCUMENT_REPORT_FILTER_ITEM =
  "GET_PROCUMENT_REPORT_FILTER_ITEM";

//civil budget report
export const GET_CIVIL_PROJECT_BUDGET_REPORT =
  "GET_CIVIL_PROJECT_BUDGET_REPORT";
export const GET_CIVIL_PROJECT_BUDGET_REPORT_EXPORT =
  "GET_CIVIL_PROJECT_BUDGET_REPORT_EXPORT";
export const GET_CIVIL_ACTIVITY_BUDGET_REPORT =
  "GET_CIVIL_ACTIVITY_BUDGET_REPORT";
export const GET_CIVIL_ACTIVITY_BUDGET_REPORT_EXPORT =
  "GET_CIVIL_ACTIVITY_BUDGET_REPORT_EXPORT";
export const GET_CIVIL_WBS_BUDGET_REPORT = "GET_CIVIL_WBS_BUDGET_REPORT";
export const GET_CIVIL_WBS_BUDGET_REPORT_EXPORT =
  "GET_CIVIL_WBS_BUDGET_REPORT_EXPORT";
export const GET_CIVIL_PROJECT_BUDGET_REPORT_FILTER_PROJECT =
  "GET_CIVIL_PROJECT_BUDGET_REPORT_FILTER_PROJECT";
export const GET_CIVIL_WBS_BUDGET_REPORT_FILTER_PROJECT =
  "GET_CIVIL_WBS_BUDGET_REPORT_FILTER_PROJECT";
export const GET_CIVIL_WBS_BUDGET_REPORT_FILTER_WBS =
  "GET_CIVIL_WBS_BUDGET_REPORT_FILTER_WBS";
export const GET_CIVIL_ACTIVITY_BUDGET_REPORT_FILTER_ACTIVITY =
  "GET_CIVIL_ACTIVITY_BUDGET_REPORT_FILTER_ACTIVITY";
export const GET_CIVIL_ACTIVITY_BUDGET_REPORT_FILTER_WBS =
  "GET_CIVIL_ACTIVITY_BUDGET_REPORT_FILTER_WBS";
export const GET_CIVIL_ACTIVITY_BUDGET_REPORT_FILTER_PROJECT =
  "GET_CIVIL_ACTIVITY_BUDGET_REPORT_FILTER_PROJECT";
export const GET_CIVIL_WBS_BUDGET_REPORT_TOTAL =
  "GET_CIVIL_WBS_BUDGET_REPORT_TOTAL";
export const GET_CIVIL_ACTIVITY_BUDGET_REPORT_TOTAL =
  "GET_CIVIL_ACTIVITY_BUDGET_REPORT_TOTAL";
export const GET_CIVIL_ACTIVITY_BUDGET_REPORT_ACTUAL_MATERIAL =
  "GET_CIVIL_ACTIVITY_BUDGET_REPORT_ACTUAL_MATERIAL";
export const GET_CIVIL_ACTIVITY_BUDGET_REPORT_ACTUAL_MATERIAL_EXPORT =
  "GET_CIVIL_ACTIVITY_BUDGET_REPORT_ACTUAL_MATERIAL_EXPORT";
export const GET_SOURCE_CATEGORY_SUMMARY_REPORT =
  "GET_SOURCE_CATEGORY_SUMMARY_REPORT";
export const GET_SUB_SOURCE_CATEGORY_SUMMARY_REPORT =
  "GET_SUB_SOURCE_CATEGORY_SUMMARY_REPORT";

export const GET_SOURCE_CATEGORY_SUMMARY_REPORT_EXPORT =
  "GET_SOURCE_CATEGORY_SUMMARY_REPORT_EXPORT";
export const GET_SUB_SOURCE_CATEGORY_SUMMARY_REPORT_EXPORT =
  "GET_SUB_SOURCE_CATEGORY_SUMMARY_REPORT_EXPORT";
export const GET_CIVIL_PROJECT_BEDGET_REPORT_ADMIN_EXPENSE =
  "GET_CIVIL_PROJECT_BEDGET_REPORT_ADMIN_EXPENSE";
export const GET_CIVIL_PROJECT_BEDGET_REPORT_ADMIN_EXPENSE_EXPORT =
  "GET_CIVIL_PROJECT_BEDGET_REPORT_ADMIN_EXPENSE_EXPORT";

export const GET_CIVIL_PROJECT_BEDGET_REPORT_PETTY_CASH =
  "GET_CIVIL_PROJECT_BEDGET_REPORT_PETTY_CASH";
export const GET_CIVIL_PROJECT_BEDGET_REPORT_PETTY_CASH_EXPORT =
  "GET_CIVIL_PROJECT_BEDGET_REPORT_PETTY_CASH_EXPORT";

//project dashboard

export const GET_BD_PROJECT_DASHBOARD = "GET_BD_PROJECT_DASHBOARD";
export const GET_BD_PROJECT_CONSOLIDATED_DASHBOARD =
  "GET_BD_PROJECT_CONSOLIDATED_DASHBOARD";
export const GET_BD_PROJECT_CONSOLIDATED_DASHBOARD_EXPORT =
  "GET_BD_PROJECT_CONSOLIDATED_DASHBOARD_EXPORT";
export const GET_BD_PROJECT_CONSOLIDATED_DASHBOARD_MD =
  "GET_BD_PROJECT_CONSOLIDATED_DASHBOARD_MD";
export const GET_COURT_CASE_DASHBOARD = "GET_COURT_CASE_DASHBOARD";
export const GET_COURT_CASE_DASHBOARD_EXPORT =
  "GET_COURT_CASE_DASHBOARD_EXPORT";
export const GET_BD_LAND_DISPUTE_DASHBOARD = "GET_BD_LAND_DISPUTE_DASHBOARD";
export const GET_BD_LEGAL_DASHBOARD = "GET_BD_LEGAL_DASHBOARD";
export const GET_BD_LEGAL_DASHBOARD_EXPORT = "GET_BD_LEGAL_DASHBOARD_EXPORT";
export const GET_BD_LAND_DISPUTE_DASHBOARD_EXPORT =
  "GET_BD_LAND_DISPUTE_DASHBOARD_EXPORT";
export const GET_LIAISON_PROSESS_PLAN_DASHBOARD =
  "GET_LIAISON_PROSESS_PLAN_DASHBOARD";
export const GET_LIAISON_PROSESS_PLAN_DASHBOARD_EXPORT =
  "GET_LIAISON_PROSESS_PLAN_DASHBOARD_EXPORT";
export const GET_LIAISON_DOCUMENTAION_TASK_PLAN_DASHBOARD =
  "GET_LIAISON_DOCUMENTAION_TASK_PLAN_DASHBOARD";
export const GET_LIAISON_DOCUMENTAION_TASK_PLAN_DASHBOARD_EXPORT =
  "GET_LIAISON_DOCUMENTAION_TASK_PLAN_DASHBOARD_EXPORT";
export const GET_PROJECT_FILE_AQUISTION_PENDING_DASHBOARD =
  "GET_PROJECT_FILE_AQUISTION_PENDING_DASHBOARD";
export const GET_PROJECT_FILE_AQUISTION_PENDING_DASHBOARD_EXPORT =
  "GET_PROJECT_FILE_AQUISTION_PENDING_DASHBOARD_EXPORT";
export const GET_APF_TASK_PLAN_QUERY_DASHBOARD =
  "GET_APF_TASK_PLAN_QUERY_DASHBOARD";
export const GET_APF_TASK_PLAN_QUERY_DASHBOARD_EXPORT =
  "GET_APF_TASK_PLAN_QUERY_DASHBOARD_EXPORT";

//SITE SUMMARY

export const GET_SITE_SUMMARY_REPORT = "GET_SITE_SUMMARY_REPORT";
export const GET_SITE_SUMMARY_DETAIL_REPORT = "GET_SITE_SUMMARY_DETAIL_REPORT";
export const GET_SITE_STATUS = "GET_SITE_STATUS";
export const GET_SITE_SUMMARY_REPORT_FILTER_PROJECT =
  "GET_SITE_SUMMARY_REPORT_FILTER_PROJECT";
export const GET_SITE_SUMMARY_DETAIL_REPORT_FILTER_PROJECT =
  "GET_SITE_SUMMARY_DETAIL_REPORT_FILTER_PROJECT";
export const GET_SITE_SUMMARY_REPORT_EXPORT = "GET_SITE_SUMMARY_REPORT_EXPORT";
export const GET_SITE_SUMMARY_DETAIL_REPORT_EXPORT =
  "GET_SITE_SUMMARY_DETAIL_REPORT_EXPORT";

export const GET_BD_PROJECT_AQUISTION_DASHBOARD_FILTER_PROJECT =
  "GET_BD_PROJECT_AQUISTION_DASHBOARD_FILTER_PROJECT";
export const GET_TASK_DASHBOARD = "GET_TASK_DASHBOARD";
export const GET_TASK_DASHBOARD_EXPORT = "GET_TASK_DASHBOARD_EXPORT";

export const GET_ORGANIZATION_STRUCTURE = "GET_ORGANIZATION_STRUCTURE";
export const GET_CIVIL_WBS_PROGRESS = "GET_CIVIL_WBS_PROGRESS";
export const GET_CIVIL_ACTIVITY_PROGRESS = "GET_CIVIL_ACTIVITY_PROGRESS";

export const GET_CIVIL_WBS_PROGRESS1 = "GET_CIVIL_WBS_PROGRESS1";
export const GET_CIVIL_ACTIVITY_PROGRESS1 = "GET_CIVIL_ACTIVITY_PROGRESS1";

//MD Dashboard
export const GET_MOU_DASHBOARD = "GET_MOU_DASHBOARD";
export const GET_MOU_DASHBOARD_EXPORT = "GET_MOU_DASHBOARD_EXPORT";
export const GET_ACQUISITION_DASHBOARD = "GET_ACQUISITION_DASHBOARD";
export const GET_ACQUISITION_DASHBOARD_EXPORT =
  "GET_ACQUISITION_DASHBOARD_EXPORT";

//Compliance Calendar Report SVM
export const GET_COMPLIANCE_ITEM_REPORT = "GET_COMPLIANCE_ITEM_REPORT";
export const GET_COMPLIANCE_ITEM_REPORT_DETAIL =
  "GET_COMPLIANCE_ITEM_REPORT_DETAIL";

//Compliance Calendar Report SVM
export const GET_COMPLIANCE_ITEM_HR_REPORT = "GET_COMPLIANCE_ITEM_HR_REPORT";
export const GET_COMPLIANCE_ITEM_HR_REPORT_FILTER_CATEGORY =
  "GET_COMPLIANCE_ITEM_HR_REPORT_FILTER_CATEGORY";
export const GET_COMPLIANCE_ITEM_HR_REPORT_FILTER_COMPANY =
  "GET_COMPLIANCE_ITEM_HR_REPORT_FILTER_COMPANY";
export const GET_COMPLIANCE_GST_REPORT_FILTER_COMPANY =
  "GET_COMPLIANCE_GST_REPORT_FILTER_COMPANY";

// ITRCalendar
export const GET_COMPLIANCE_ITEM_ITR_REPORT = "GET_COMPLIANCE_ITEM_ITR_REPORT";
export const GET_COMPLIANCE_ITR_REPORT_FILTER_COMPANT =
  "GET_COMPLIANCE_ITR_REPORT_FILTER_COMPANT";
// TDSCalendar
export const GET_COMPLIANCE_ITEM_TDS_REPORT = "GET_COMPLIANCE_ITEM_TDS_REPORT";
export const GET_COMPLIANCE_TDS_REPORT_FILTER_COMPANY =
  "GET_COMPLIANCE_TDS_REPORT_FILTER_COMPANY";

// Qc Report
export const GET_QC_WORK_REPORT = "GET_QC_WORK_REPORT";
export const GET_QC_WORK_REPORT_FILTER_PROJECT =
  "GET_QC_WORK_REPORT_FILTER_PROJECT";
export const GET_QC_WORK_REPORT_PASSING_DETAIL =
  "GET_QC_WORK_REPORT_PASSING_DETAIL";
export const GET_QC_WORK_REPORT_PASSING_DETAIL_EXPORT =
  "GET_QC_WORK_REPORT_PASSING_DETAIL_EXPORT";

export const GET_QC_OBSERVATION_REPORT_PASSING_DETAIL =
  "GET_QC_OBSERVATION_REPORT_PASSING_DETAIL";
export const GET_QC_OBSERVATION_REPORT_PASSING_DETAIL_EXPORT =
  "GET_QC_OBSERVATION_REPORT_PASSING_DETAIL_EXPORT";

// Qc Observation
export const GET_QC_OBSERVATION_REPORT = "GET_QC_OBSERVATION_REPORT";
export const GET_QC_OBSERVATION_REPORT_HANDLED_BY =
  "GET_QC_OBSERVATION_REPORT_HANDLED_BY";
export const GET_QC_OBSERVATION_REPORT_FILTER_PROJECT =
  "GET_QC_OBSERVATION_REPORT_FILTER_PROJECT";
export const GET_QC_WORK_REPORT_FILTER_HANDLED_BY =
  "GET_QC_WORK_REPORT_FILTER_HANDLED_BY";
export const GET_QC_WORK_REPORT_DETAIL = "GET_QC_WORK_REPORT_DETAIL";
export const GET_QC_WORK_REPORT_FILTER_RAISED_BY =
  "GET_QC_WORK_REPORT_FILTER_RAISED_BY";
export const GET_QC_WORK_REPORT_EXPORT = "GET_QC_WORK_REPORT_EXPORT";
export const GET_QC_OBSERVATION_REPORT_EXPORT =
  "GET_QC_OBSERVATION_REPORT_EXPORT";
export const GET_QC_OBSERVATION_REPORT_FILTER_RAISED_BY =
  "GET_QC_OBSERVATION_REPORT_FILTER_RAISED_BY";
export const GET_QC_OBSERVATION_REPORT_FILTER_HANDLED_BY =
  "GET_QC_OBSERVATION_REPORT_FILTER_HANDLED_BY";
export const GET_QC_WALK_THROUGH_REPORT_EXPORT =
  "GET_QC_WALK_THROUGH_REPORT_EXPORT";
export const GET_QC_TRAINING_REPORT_EXPORT = "GET_QC_TRAINING_REPORT_EXPORT";
export const GET_QC_OBSERVATION_REPORT_DETAIL =
  "GET_QC_OBSERVATION_REPORT_DETAIL";
export const GET_QC_TRAINING_REPORT = "GET_QC_TRAINING_REPORT";
export const GET_QC_WALK_THROUGH_REPORT = "GET_QC_WALK_THROUGH_REPORT";

export const GET_QC_TRAINING_REPORT_FILTER_PROJECT =
  "GET_QC_TRAINING_REPORT_FILTER_PROJECT";
